import { render, staticRenderFns } from "./key-area-drawer.component.vue?vue&type=template&id=16e93ecc&scoped=true&"
import script from "./key-area-drawer.component.vue?vue&type=script&lang=ts&"
export * from "./key-area-drawer.component.vue?vue&type=script&lang=ts&"
import style0 from "./key-area-drawer.component.vue?vue&type=style&index=0&id=16e93ecc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e93ecc",
  null
  
)

export default component.exports